var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3051_380)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 28.9724L22.955 21.0174C24.5283 19.4441 25.5998 17.4395 26.0338 15.2572C26.4679 13.0749 26.2451 10.8129 25.3936 8.75728C24.5421 6.70162 23.1002 4.94462 21.2502 3.70846C19.4001 2.4723 17.225 1.8125 15 1.8125C12.775 1.8125 10.5999 2.4723 8.74985 3.70846C6.8998 4.94462 5.45786 6.70162 4.60637 8.75728C3.75488 10.8129 3.53209 13.0749 3.96616 15.2572C4.40023 17.4395 5.47168 19.4441 7.045 21.0174L15 28.9724Z",
    fill: "#0090D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0781 9.58936H14.8608V17.0115H16.0781V9.58936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2143 16.4038H9.45689L15.717 10.157H21.5212L15.2143 16.4038ZM23 8.94238H15.4657L15.0346 9.12028L8 16.1399V17.6185H15.4657L15.8938 17.4421L23 10.4078V8.94238Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3051_380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.83328317e9f861f2509d53909f31fa88.svg";
export { ForwardRef as ReactComponent };